import { createSlice } from "@reduxjs/toolkit";

interface ICommonState {
  filterFrom: number;
  filterTo: number;
  atc_id: string;
  headerSearch: {
    value: string;
    title: string;
    data: any[];
  };
}
const initialState: ICommonState = {
  filterFrom: 0,
  filterTo: 0,
  atc_id: "",
  headerSearch: {
    value: "",
    title: "",
    data: [],
  },
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setFilterValues(state, action) {
      state.filterFrom = action.payload.from;
      state.filterTo = action.payload.to;
    },

    clearFilterValues(state) {
      state.filterFrom = 0;
      state.filterTo = 0;
      state.atc_id = "";
    },

    setAtcFilterValue(state, action) {
      state.atc_id = action.payload.atc_id;
    },
    clearAtcFilterValue(state) {
      state.atc_id = "";
    },
    setHeaderSearchTitle(state, action) {
      state.headerSearch.title = action.payload.title;
      state.headerSearch.value = action.payload.value;
    },
    setHeaderSearchValue(state, action) {
      state.headerSearch.value = action.payload.value;
    },
  },
});

export const {
  setFilterValues,
  setAtcFilterValue,
  setHeaderSearchTitle,
  setHeaderSearchValue,
  clearAtcFilterValue,
  clearFilterValues,
} = commonSlice.actions;
export default commonSlice.reducer;
